var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"quote-extraction-page"}},[(_vm.topics)?_c('page-header-component',{staticClass:"mb-2",attrs:{"icon":"bi bi-chat-quote","title":"Quotes Extraction","topics":_vm.topics}}):_vm._e(),(_vm.current_tab == 'Kol')?_c('tab-kol-entity-component'):_c('tab-data-mentah-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }